"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.color = exports.background = exports.TagStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _grid = require("../../constants/grid");
var _typography = require("../../constants/typography");
const background = p => p.backgroundColor;
exports.background = background;
const color = p => p.textColor;
exports.color = color;
const TagStyled = (0, _styled.default)("span")`
    display: inline-flex;
    background: ${background};
    color: ${color};
    font-size: ${_typography.tag.size}px;
    line-height: ${_grid.gridSize * 6}px;
    font-weight: ${_typography.tag.fontWeight};
    padding: 0px ${_grid.gridSize * 2}px;
    border-radius: 2px;
    white-space: nowrap;
`;
exports.TagStyled = TagStyled;
//# sourceMappingURL=TagStyled.js.map